<template lang="pug">
  section(class="separable")
    div.marginTop(class="container")
      sincronizar-processo(v-if="showSincronizar", @carregaProcessos="carregaProcessos", @cancelar="showSincronizar = false")
      el-row
        el-col.cardProcesso(:span="24")
          div(class="card")
            div(class="card-header").titulo Processos existentes
              el-button.buttonProcesso(
                v-if="isCentral",
                type="primary"
                @click="showSincronizar = true"
                )
                span.center
                  i.fal.fa-sync-alt
                  | &nbsp Sincronizar processo
            div.marginDivider
              app-divider-refresh-button(
                :label="headerLabel",
                :hasButton="hasRefreshButton",
                :content="tooltipRefreshButton"
                :showBorder="false",
              )
            div(class="card-body")
              el-row
                .divider
              .table-pointer
                el-table(
                  :data='processos',
                  :default-sort = "{ prop: 'id', order: 'descending' }",
                  @sort-change="sort",
                  @row-click="goTo",
                  style="cursor: pointer"
                )
                  template(slot="empty", v-if="!isBusca") Não há registros.
                  template(slot="empty", v-else) Não há registros.
                  el-table-column(
                    min-width="40"
                  )
                    template(slot-scope="scope")
                      .green
                        i.fal.fa-eye(style="margin-left: 10px")
                  el-table-column(
                    prop='numeroProcesso',
                    label='Processo',
                    min-width="120"
                  )
                  el-table-column(
                    label='CPF/CNPJ do interessado',
                    min-width='195',
                    prop='cpfCnpjInteressado'
                    :formatter="formatCpfCnpj"
                  )
                  el-table-column(
                    label='Nome/Razão social do interessado',
                    prop='nomeRazaoSocialInteressado'
                    min-width='265',
                    sortable
                  )
                  el-table-column(
                    label='Munícipio',
                    prop='municipio'
                    min-width='130',
                    sortable
                  )
                  el-table-column(
                    v-if="isCentral"
                    label='Tipo de processo',
                    prop='tipo.nome',
                    sortable
                    min-width='130'
                  )
                  el-table-column(
                    v-if="!isCentral"
                    label='Tipo de processo',
                    prop='tipo',
                    sortable
                    min-width='130'
                  )
                  el-table-column(
                    label='Status',
                    prop='status',
                    min-width='115',
                    sortable,
                  )
                    template(slot-scope="scope")
                      span {{ setStatusProcesso(scope.row) }}

              slot

</template>

<script>
import { mapActions } from 'vuex'
import SincronizarProcesso from './SincronizarProcesso'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
const {setStatus} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    SincronizarProcesso,
    AppDividerRefreshButton
  },

  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isBusca: {
      type: Boolean,
      default: false
    },
    processos: {
      type: Array,
      required: true
    },
    isCentral: {
      type: Boolean,
      default: true
    },
    headerLabel: {
      type: String,
      default: 'Listagem de processos existentes'
    }
  },

  data () {
    return {
      hasRefreshButton: false,
      tooltipRefreshButton: '',
      showSincronizar: false
    }
  },

  methods: {
    ...mapActions({
      setLoader: 'loader/setLoader',
      resetLoader: 'loader/resetLoader'
    }),
    setStatusProcesso (prop) {
      if (this.isCentral) {
        return setStatus(prop)
      }
      return prop.status
    },

    checkVazio (row, column, prop) {
      return (prop !== '' && prop) ? prop : '-'
    },

    goTo (data) {
      this.$emit('goTo', data, this.setLoader, this.resetLoader)
    },

    formatCpfCnpj (row, column, prop) {
      if (!prop) {
        return '-'
      }
      if (prop.length === 11) {
        return prop.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, '$1.$2.$3-$4')
      }
      return prop.replace(/^([\d]{2})([\d]{3})([\d]{3})([\d]{4})([\d]{2})$/, '$1.$2.$3/$4-$5')
    },

    sort (data) {
      const ordenacaoFiltro = {
        ordenacao: '',
        tipo: ''
      }

      switch (data.prop) {
        case 'nomeRazaoSocialInteressado':
          ordenacaoFiltro.ordenacao = 'nomeRazaoSocialInteressado'
          break
        case 'tipo.nome':
          ordenacaoFiltro.ordenacao = 'tipo.nome'
          break
        case 'status':
          ordenacaoFiltro.ordenacao = 'status'
          break
        default:
          ordenacaoFiltro.ordenacao = 'dataCadastro'
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    },

    async carregaProcessos () {
      this.$emit('carregaProcessos')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.titulo {
  color: #424242;
  font-size: 1.5rem;
}
.divider {
  border: 1px solid $border-color;
  margin-bottom: 2px;
}
.marginDivider {
  margin-left: 24px;
  margin-bottom: -25px;
}
.center {
  display: flex;
  align-items: center;
}
.green {
  color: #009f61;
}

@media (max-width: 780px) {
  .buttonProcesso {
    margin-top: 15px;
  }

  .cardProcesso {
    width: 82%;
    left: 45px;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/ListagemProcessos.vue